export default __webpack_public_path__ + "static/media/product-1-2.57039790.jpg";